import { Injectable, OnInit, Output, EventEmitter } from '@angular/core';
import { AVAILABILITY } from './mock-users';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import { Router } from "@angular/router";
import * as moment from 'moment';


@Injectable()
export class AvailabilityService extends AuthService{
    
    private URLGetAvaialabilityCleaner = "api/v1/getCleanerAvailability/:id";
    private ID = ":id";
    private availability: Array<object> = [];
    constructor(public http: Http, private auth: AuthService, public router: Router) {
        super(http, router);
    }

    public getAvailabilityCleaner(id: string) {
        let URLGetAvaialabilityCleaner = this.URLGetAvaialabilityCleaner.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetAvaialabilityCleaner, { headers: this.headers })
        .map((res: Response) => {
            return this.parseAvailability(res.json());
        });
    }

    private parseAvailability(availability){
        this.availability = [];
        let counter = 0, busyPeriod = false, index = 0;
        let selection = false , n_elements = 0;
        for(let day of availability["summary"]){
                var array_summary = day["day_summary"].match(/.{1,6}/g);
                index = 0;
                var dayO = {
                    date: moment(day["date"],"YYYY-MM-DD").format("DD/MM/YYYY"),
                    hours : []
                }
                selection = false;
                counter = 0;
                for(let hour of array_summary){
                    var isFree = new RegExp('^[E]*$');
                    var isBusy = new RegExp('[B]');
                    var isNotAvailable = new RegExp('[X]');
                    var h = { available: null, service: []};
                    //console.log(hour)
                    if(isFree.test(hour)) {
                            h["available"] = "available";
                            dayO["hours"].push(h);  
                    }
                    else if(isBusy.test(hour)) {
                            h["available"] = "busy";
                            dayO["hours"].push(h);
                            var i = 0;
                            for(let service of availability["services"]){
                                //console.log(service);
                                
                                if(day["date"] == service["date"]) {
                                    h["service"] = service;
                                    n_elements = (service["n_hours"] * 2) + 1;
                                    selection = true;
                                    availability["services"].splice(i,1);
                                    array_summary.splice(index,n_elements - 1);
                                    counter++;
                                    break;
                                }
                                i++;
                            }
                    }
                    else if(isNotAvailable.test(hour)) {
                            
                            h["available"] = "notAvailable";
                            dayO["hours"].push(h);  
                    }
                    index++;
                }
                
                this.availability.push(dayO);
        }
        this.availability["cleanerName"] = availability["cleanerData"]["cleanerName"];
        return this.availability;
    }

}


// WEBPACK FOOTER //
// ./src/app/injections/availability.service.ts